import * as moment from 'moment';

export class TeamStatistic {
    id: number;
    stage: number;
    passesAccurate: number;
    possessionTimeTotal: string;
    shotsOutsideBox: number;
    yellowCardsTotal: number;
    shotsInsideBox: number;
    passesTotal: number;
    passesPercent: string;
    foulsTotal: number;
    savesTotal: number;
    shotsBlocked: number;
    offSidesTotal: number;
    shotsTotal: number;
    shotsOnGoal: number;
    cornersTotal: number;
    shotsOffGoal: number;
    redCardsTotal: number;
    teamId: number;
    matchDate: moment.Moment;
}



// WEBPACK FOOTER //
// /Users/mac/PlayGround/src/app/shared/team-statistic.model.ts